module.exports = __webpack_public_path__ + "img/email.8d9b2542.svg";